import { defineNuxtPlugin } from '#app';
import * as L from 'leaflet';
import { LMap, LTileLayer, LMarker, LTooltip } from '@vue-leaflet/vue-leaflet';
import 'leaflet/dist/leaflet.css';
export default defineNuxtPlugin((nuxtApp) => {
    if (!import.meta.server) {
        interface LeafletIconDefault extends L.Icon.Default {
            _getIconUrl?: () => string;
        }

        delete (L.Icon.Default.prototype as LeafletIconDefault)._getIconUrl;
        L.Icon.Default.mergeOptions({
            iconRetinaUrl: new URL('leaflet/dist/images/marker-icon-2x.png', import.meta.url).href,
            iconUrl: new URL('leaflet/dist/images/marker-icon.png', import.meta.url).href,
            shadowUrl: new URL('leaflet/dist/images/marker-shadow.png', import.meta.url).href
        });
    }

    nuxtApp.vueApp.component('LMap', LMap);
    nuxtApp.vueApp.component('LTileLayer', LTileLayer);
    nuxtApp.vueApp.component('LMarker', LMarker);
    nuxtApp.vueApp.component('LTooltip', LTooltip);
});
